// src/components/common/Layout/Layout.jsx
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import Footer from '../Footer/Footer';
import { useAuth } from '../../../hooks/useAuth';
import styles from './Layout.module.css';

const Layout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const { user, isAuthenticated } = useAuth();

  const toggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  // Keep --sidebar-width CSS variable in sync with sidebar state
  // so fixed elements (e.g. the fixed action bar in order pages) can offset correctly
  useEffect(() => {
    const width = sidebarCollapsed ? '80px' : '280px';
    document.documentElement.style.setProperty('--sidebar-width', width);
  }, [sidebarCollapsed]);

  // Also set initial value on mount
  useEffect(() => {
    document.documentElement.style.setProperty('--sidebar-width', '280px');
    return () => {
      document.documentElement.style.removeProperty('--sidebar-width');
    };
  }, []);

  if (!isAuthenticated) {
    return <Outlet />;
  }

  return (
    <div className={styles.layoutContainer}>
      <Header 
        user={user}
        onToggleSidebar={toggleSidebar}
        sidebarCollapsed={sidebarCollapsed}
      />
      
      <div className={styles.layoutBody}>
        <Sidebar 
          user={user}
          collapsed={sidebarCollapsed}
          onToggle={toggleSidebar}
        />
        
        <main className={`${styles.mainContent} ${sidebarCollapsed ? styles.expanded : ''}`}>
          <div className={styles.contentWrapper}>
            <Outlet />
          </div>
          <Footer />
        </main>
      </div>
    </div>
  );
};

export default Layout;